import { WidgetType } from 'types/widget.types';
import {
  VERSION as basicShapeWidgetVersion,
  basicShapeWidgetVersionControllers,
} from 'widgets/BasicShapeWidget/BasicShapeWidget.upgrade';
import {
  VERSION as areaChartWidgetVersion,
  areaChartWidgetVersionControllers,
} from 'widgets/ChartWidgets/Area/AreaChartWidget.upgrade';
import {
  VERSION as areaSplineChartWidgetVersion,
  areaSplineChartWidgetVersionControllers,
} from 'widgets/ChartWidgets/AreaSplineChartWidget/AreaSplineChartWidget.upgrade';
import {
  VERSION as barChartWidgetVersion,
  barChartWidgetVersionControllers,
} from 'widgets/ChartWidgets/BarChartWidget/BarChartWidget.upgrade';
import {
  VERSION as cloudBubbleChartWidgetVersion,
  cloudBubbleChartWidgetVersionControllers,
} from 'widgets/ChartWidgets/CloudBubbleChartWidget/CloudBubbleChartWidget.upgrade';
import {
  VERSION as columnChartWidgetVersion,
  columnChartWidgetVersionControllers,
} from 'widgets/ChartWidgets/ColumnChartWidget/ColumnChartWidget.upgrade';
import {
  VERSION as funnelChartWidgetVersion,
  funnelChartWidgetVersionControllers,
} from 'widgets/ChartWidgets/FunnelChartWidget/FunnelChartWidget.upgrade';
import {
  VERSION as halfPieChartWidgetVersion,
  halfPieChartWidgetVersionControllers,
} from 'widgets/ChartWidgets/HalfPieChartWidget/HalfPieChartWidget.upgrade';
import {
  VERSION as histogramChartWidgetVersion,
  histogramChartWidgetVersionControllers,
} from 'widgets/ChartWidgets/HistogramWidget/HistogramChartWidget.upgrade';
import {
  VERSION as lineChartWidgetVersion,
  lineChartWidgetVersionControllers,
} from 'widgets/ChartWidgets/LineChartWidget/LineChartWidget.upgrade';
import {
  VERSION as pieChartWidgetVersion,
  pieChartWidgetVersionControllers,
} from 'widgets/ChartWidgets/PieChartWidget/PieChartWidget.upgrade';
import {
  VERSION as pyramidChartWidgetVersion,
  pyramidChartWidgetVersionControllers,
} from 'widgets/ChartWidgets/PyramidChartWidget/PyramidChartWidget.upgrade';
import {
  VERSION as bubbleChartWidgetVersion,
  scatterBubbleChartWidgetVersionControllers,
} from 'widgets/ChartWidgets/ScatterBubbleChartWidget/ScatterBubbleChartWidget.upgrade';
import {
  VERSION as scatterPlotChartWidgetVersion,
  scatterPlotChartWidgetVersionControllers,
} from 'widgets/ChartWidgets/ScatterPlotChartWidget/ScatterPlotChartWidget.upgrade';
import {
  VERSION as splineChartWidgetVersion,
  splineChartWidgetVersionControllers,
} from 'widgets/ChartWidgets/SplineChartWidget/SplineChartWidget.upgrade';
import {
  VERSION as stackedAreaChartWidgetVersion,
  stackedAreaChartWidgetVersionControllers,
} from 'widgets/ChartWidgets/StackedArea/StackedAreaChartWidget.upgrade';
import {
  VERSION as stackedBarChartWidgetVersion,
  stackedBarChartWidgetVersionControllers,
} from 'widgets/ChartWidgets/StackedBar/StackedBarChartWidget.upgrade';
import {
  VERSION as stackedColumnChartWidgetVersion,
  stackedColumnChartWidgetVersionControllers,
} from 'widgets/ChartWidgets/StackedColumn/StackedColumnChartWidget.upgrade';
import {
  VERSION as treeMapChartWidgetVersion,
  treeMapChartWidgetVersionControllers,
} from 'widgets/ChartWidgets/TreeMapChartWidget/TreeMapChartWidget.upgrade';
import {
  VERSION as wordCloudChartWidgetVersion,
  wordCloudChartWidgetVersionControllers,
} from 'widgets/ChartWidgets/WordCloud/WordCloudWidget.upgrade';
import {
  LottieWidgetVersionControllers,
  VERSION as lottieWidgetVersion,
} from 'widgets/LottieWidget/LottieWidget.upgrade';
import { VERSION as mapWidgetVersion, mapWidgetVersionControllers } from 'widgets/MapWidget/MapWidget.upgrade';
import {
  VERSION as progressChartWidgetVersion,
  progressChartWidgetVersionControllers,
} from 'widgets/ProgressChartWidget/ProgressChartWidget.upgrade';
import {
  VERSION as QRCodeWidgetVersion,
  QRCodeWidgetVersionControllers,
} from 'widgets/QRCodeWidget/QRCodeWidget.upgrade';
import {
  VERSION as multipleChoicesWidgetVersion,
  multipleChoicesWidgetVersionControllers,
} from 'widgets/ResponsiveWidgets/MultipleChoicesWidget/MultipleChoicesWidget.upgrade';
import {
  statChartWidgetVersionControllers,
  VERSION as statChartWigetVersion,
} from 'widgets/ResponsiveWidgets/StatChartWidget/StatChartWidget.upgrade';
import {
  VERSION as SignatureWidgetVersion,
  SignatureWidgetVersionControllers,
} from 'widgets/SignatureWidget/SignatureWidget.upgrade';
import {
  VERSION as labelTextWidgetVersion,
  labelTextWidgetVersionControllers,
} from 'widgets/TextBasedWidgets/LabelTextWidget/LabelTextWidget.upgrade';
import {
  VERSION as tableWidgetVersion,
  tableWidgetVersionControllers,
} from 'widgets/TextBasedWidgets/TableWidget/TableWidget.upgrade';
import {
  VERSION as textWidgetVersion,
  textWidgetVersionControllers,
} from 'widgets/TextBasedWidgets/TextWidget/TextWidget.upgrade';
import {
  VideoEmbedWidgetVersionControllers,
  VERSION as videoEmbedWidgetVersion,
} from 'widgets/VideoEmbedWidget/VideoEmbedWidget.upgrade';

import {
  VERSION as ComboWidgetVersion,
  comboChartWidgetVersionControllers,
} from '../ChartWidgets/ComboChartWidget/ComboChartWidget.upgrade';
import { VERSION as formWidgetVersion, formWidgetVersionControllers } from '../FormWidget/FormWidget.upgrade';
import { VERSION as groupWidgetVersion, groupWidgetVersionControllers } from '../GroupWidget/GroupWidget.upgrade';
import { VERSION as iconWidgetVersion, iconWidgetVersionControllers } from '../IconWidget/IconWidget.upgrade';
import { VERSION as imageWidgetVersion, imageWidgetVersionControllers } from '../ImageWidget/ImageWidget.upgrade';
import {
  VERSION as lineIconWidgetVersion,
  lineIconWidgetVersionControllers,
} from '../Lines/LineIconWidget/LineIconWidget.upgrade';
import { VERSION as lineWidgetVersion, lineWidgetVersionControllers } from '../Lines/LineWidget/LineWidget.upgrade';
import { WidgetVersionConfig } from './WidgetVersionManager.types';

export const widgetVersionConfig: WidgetVersionConfig = {
  [WidgetType.Image]: {
    controllers: imageWidgetVersionControllers,
    latestVersion: imageWidgetVersion,
  },
  [WidgetType.Text]: {
    controllers: textWidgetVersionControllers,
    latestVersion: textWidgetVersion,
  },
  [WidgetType.Table]: {
    controllers: tableWidgetVersionControllers,
    latestVersion: tableWidgetVersion,
  },
  [WidgetType.Icon]: {
    controllers: iconWidgetVersionControllers,
    latestVersion: iconWidgetVersion,
  },
  [WidgetType.Line]: {
    controllers: lineWidgetVersionControllers,
    latestVersion: lineWidgetVersion,
  },
  [WidgetType.BasicShape]: {
    controllers: basicShapeWidgetVersionControllers,
    latestVersion: basicShapeWidgetVersion,
  },
  [WidgetType.BarChart]: {
    controllers: barChartWidgetVersionControllers,
    latestVersion: barChartWidgetVersion,
  },
  [WidgetType.ColumnChart]: {
    controllers: columnChartWidgetVersionControllers,
    latestVersion: columnChartWidgetVersion,
  },
  [WidgetType.LineChart]: {
    controllers: lineChartWidgetVersionControllers,
    latestVersion: lineChartWidgetVersion,
  },
  [WidgetType.PieChart]: {
    controllers: pieChartWidgetVersionControllers,
    latestVersion: pieChartWidgetVersion,
  },
  [WidgetType.Group]: {
    controllers: groupWidgetVersionControllers,
    latestVersion: groupWidgetVersion,
  },
  [WidgetType.StackedBarChart]: {
    controllers: stackedBarChartWidgetVersionControllers,
    latestVersion: stackedBarChartWidgetVersion,
  },
  [WidgetType.StackedColumnChart]: {
    controllers: stackedColumnChartWidgetVersionControllers,
    latestVersion: stackedColumnChartWidgetVersion,
  },
  [WidgetType.FunnelChart]: {
    controllers: funnelChartWidgetVersionControllers,
    latestVersion: funnelChartWidgetVersion,
  },
  [WidgetType.PyramidChart]: {
    controllers: pyramidChartWidgetVersionControllers,
    latestVersion: pyramidChartWidgetVersion,
  },
  [WidgetType.CloudBubbleChart]: {
    controllers: cloudBubbleChartWidgetVersionControllers,
    latestVersion: cloudBubbleChartWidgetVersion,
  },
  [WidgetType.ScatterPlotChart]: {
    controllers: scatterPlotChartWidgetVersionControllers,
    latestVersion: scatterPlotChartWidgetVersion,
  },
  [WidgetType.SplineChart]: {
    controllers: splineChartWidgetVersionControllers,
    latestVersion: splineChartWidgetVersion,
  },
  [WidgetType.AreaSplineChart]: {
    controllers: areaSplineChartWidgetVersionControllers,
    latestVersion: areaSplineChartWidgetVersion,
  },
  [WidgetType.TreeMapChart]: {
    controllers: treeMapChartWidgetVersionControllers,
    latestVersion: treeMapChartWidgetVersion,
  },
  [WidgetType.ScatterBubbleChart]: {
    controllers: scatterBubbleChartWidgetVersionControllers,
    latestVersion: bubbleChartWidgetVersion,
  },
  [WidgetType.ProgressChart]: {
    controllers: progressChartWidgetVersionControllers,
    latestVersion: progressChartWidgetVersion,
  },
  [WidgetType.StatChart]: {
    controllers: statChartWidgetVersionControllers,
    latestVersion: statChartWigetVersion,
  },
  [WidgetType.AreaChart]: {
    controllers: areaChartWidgetVersionControllers,
    latestVersion: areaChartWidgetVersion,
  },
  [WidgetType.StackedAreaChart]: {
    controllers: stackedAreaChartWidgetVersionControllers,
    latestVersion: stackedAreaChartWidgetVersion,
  },
  [WidgetType.LabelText]: {
    controllers: labelTextWidgetVersionControllers,
    latestVersion: labelTextWidgetVersion,
  },
  [WidgetType.QRCode]: {
    controllers: QRCodeWidgetVersionControllers,
    latestVersion: QRCodeWidgetVersion,
  },
  [WidgetType.WordCloudChart]: {
    controllers: wordCloudChartWidgetVersionControllers,
    latestVersion: wordCloudChartWidgetVersion,
  },
  [WidgetType.HalfPieChart]: {
    controllers: halfPieChartWidgetVersionControllers,
    latestVersion: halfPieChartWidgetVersion,
  },
  [WidgetType.HistogramChart]: {
    controllers: histogramChartWidgetVersionControllers,
    latestVersion: histogramChartWidgetVersion,
  },
  [WidgetType.MapChart]: {
    controllers: mapWidgetVersionControllers,
    latestVersion: mapWidgetVersion,
  },
  [WidgetType.ComboChart]: {
    controllers: comboChartWidgetVersionControllers,
    latestVersion: ComboWidgetVersion,
  },
  [WidgetType.LineIcon]: {
    controllers: lineIconWidgetVersionControllers,
    latestVersion: lineIconWidgetVersion,
  },
  [WidgetType.VideoEmbed]: {
    controllers: VideoEmbedWidgetVersionControllers,
    latestVersion: videoEmbedWidgetVersion,
  },
  [WidgetType.Lottie]: {
    controllers: LottieWidgetVersionControllers,
    latestVersion: lottieWidgetVersion,
  },
  [WidgetType.MultipleChoices]: {
    controllers: multipleChoicesWidgetVersionControllers,
    latestVersion: multipleChoicesWidgetVersion,
  },
  [WidgetType.Form]: {
    controllers: formWidgetVersionControllers,
    latestVersion: formWidgetVersion,
  },
  [WidgetType.Signature]: {
    controllers: SignatureWidgetVersionControllers,
    latestVersion: SignatureWidgetVersion,
  },
};
